import { React, useState, useEffect, useContext } from "react";
import { API_BASE_URL } from "../utils/config";
import axios from "axios";
import UploadImage from "../Img/upload.png";
import Rightarrow from "../Img/right arrow.png";
import { toast } from "react-toastify";
import NewTopNavBar from "./NewTopNavBar";
import GlobalContext from "../context/GlobalContext";
import ColorPicker from "./ColorPicker";
import SaveImg from "../../src/Img/create.png";
import { SketchPicker } from "react-color";
import { Button } from "react-bootstrap";
const GlobalLogo = () => {
  const [selectedFile, setSelectedFile] = useState();
  const [favIconFile, setFavIconFile] = useState();
  const [widgetIcon, setWidgetIcon] = useState();
  const [fileSize, setFileSize] = useState(0);
  const [adminEmail, setAdminEmail] = useState("");
  let bearerToken = localStorage.getItem("jwt_token");

  const { logoUpload, setLogoUpload } = useContext(GlobalContext);

  const config2 = {
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      "Content-Type": "multipart/form-data",
    },
  };
  function convertRgbaToObject(rgbaString) {
    // Remove "rgba(" from the start and ")" from the end, then split by commas
    const rgbaArray = rgbaString.replace(/^rgba?\(|\s+|\)$/g, "").split(",");

    // Convert the values to strings and return the object
    return {
      r: rgbaArray[0].trim(),
      g: rgbaArray[1].trim(),
      b: rgbaArray[2].trim(),
      a: rgbaArray[3].trim(),
    };
  }
  //creating state to store our color and also set color using onChange event for sketch picker
  const [sketchPickerColor, setSketchPickerColor] = useState({
    r: "241",
    g: "112",
    b: "19",
    a: "1",
  });
  const getWidgetIconcolor = () => {
    axios
      .get(`${API_BASE_URL}/wp-json/custom/v1/bg-color`, config2)
      .then((res) => {
        console.log("widgetIcon=", res.data);
        setWidgetIcon(res.data);
        // Example usage
        // const rgbaString = "rgba(241,112,19,1)";
        const rgbaObject = convertRgbaToObject(res.data);
        setSketchPickerColor(rgbaObject);
        console.log("rgbaObject=", rgbaObject);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  // destructuring rgba from state
  const { r, g, b, a } = sketchPickerColor;
  // const [sketchPickerColor, setSketchPickerColor] = useState(widgetIcon);

  const saveColor = () => {
    // console.log(`color= rgba(${r},${g},${b},${a})`);
    let data = {
      bg_color: `rgba(${r},${g},${b},${a})`,
      // bg_color: widgetIcon,
    };
    axios
      .post(`${API_BASE_URL}/wp-json/custom/v1/bg-color`, data, config2)
      .then((res) => {
        console.log(res);
        setWidgetIcon(data.bg_color);
        // setLogoUpload(logoUpload ? false : true);
        // document.getElementById("fav_file").value = "";
        toast.success("Color updated successfully");
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const getTotoalFileSize = () => {
    // alert("dfdgdf");
    axios
      .get(`${API_BASE_URL}/wp-json/custom/v1/file-tracking`, config2)
      .then((res) => {
        setFileSize(parseInt(res.data.given_size));
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const getAdminEmail = () => {
    // alert("dfdgdf");
    axios
      .get(`${API_BASE_URL}/wp-json/custom/v1/get-global-email`, config2)
      .then((res) => {
        setAdminEmail(res.data.email);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    getTotoalFileSize();
    getAdminEmail();
    getWidgetIconcolor();
  }, [widgetIcon]);
  const handleFileChange = (event) => {
    // setFeaturedImageLoading(true);

    setSelectedFile(event.target.files[0]);
  };
  const handleLogoUpload = () => {
    if (selectedFile && selectedFile.name.toLowerCase().includes("logo")) {

      const formData = new FormData();
      formData.append("file", selectedFile);
      axios
        .post(`${API_BASE_URL}/wp-json/wp/v2/media`, formData, config2)
        .then((res) => {
          console.log(res.data);
          const imageURL = res.data.guid.rendered;
          // track file size api call start
          const fileSize = { file_size: res.data.media_details.filesize };

          // axios
          //   .post(
          //     `${API_BASE_URL}/wp-json/custom/v1/track-filesize`,
          //     fileSize,
          //     config2
          //   )
          //   .then((response) => {
          //     console.log("Response data:", response.data);
          //   })
          //   .catch((error) => {
          //     console.log("Error:", error);
          //   });

          // track file size api call end
          const img = new Image();

          img.onload = function () {
            const aspectRatio = img.width / img.height;
            // if (Math.abs(aspectRatio - 40 / 13) < 1) {
            // Aspect ratio is approximately 40:13, proceed with upload
            localStorage.setItem("logoImg", imageURL);
            const fromData2 = new FormData();
            fromData2.append("image_url", imageURL);
            axios
              .post(`${API_BASE_URL}/wp-json/custom/v1/image`, fromData2, config2)
              .then((res) => {
                console.log(res);
                setLogoUpload(logoUpload ? false : true);
                document.getElementById("fav_file").value = "";
                toast.success("Logo updated successfully");
              })
              .catch((err) => {
                console.log(err);
              });
            // } else {
            //     // Aspect ratio is not 40:13, show error message
            //     toast.error("Please upload a logo with aspect ratio 40:13");
            // }
          };
          img.src = imageURL;
        })
        .catch((err) => {
          console.log(err);
        });

    } else {
      // Handle case where the file name does not contain "logo"
      console.log("The file name must contain 'logo'. Upload skipped.");
      // Optionally show a message to the user (e.g., alert or toast)
      toast.error("Please upload a file with 'logo' in its name.");
    }
  };
  const handleFavIconChange = (event) => {
    setFavIconFile(event.target.files[0]);
  };
  const handleFavIconUpload = () => {
    console.log("favIconFile=", favIconFile)
    // Check if the filename contains the word "logo"
    if (favIconFile && favIconFile.name.toLowerCase().includes("logo")) {
      const formData = new FormData();
      formData.append("file", favIconFile);
      axios
        .post(`${API_BASE_URL}/wp-json/wp/v2/media`, formData, config2)
        .then((res) => {
          console.log(res.data);
          const imageURL = res.data.guid.rendered;
          // track file size api call start
          const fileSize = { file_size: res.data.media_details.filesize };

          // axios
          //   .post(
          //     `${API_BASE_URL}/wp-json/custom/v1/track-filesize`,
          //     fileSize,
          //     config2
          //   )
          //   .then((response) => {
          //     console.log("Response data:", response.data);
          //   })
          //   .catch((error) => {
          //     console.log("Error:", error);
          //   });

          // track file size api call end

          const img = new Image();
          img.onload = function () {
            const aspectRatio = img.width / img.height;
            // if (Math.abs(aspectRatio - 40 / 13) < 1) {
            // Aspect ratio is approximately 40:13, proceed with upload
            //   localStorage.setItem("logoImg", imageURL);
            const fromData2 = new FormData();
            fromData2.append("image_url", imageURL);
            //   return;
            axios
              .post(
                `${API_BASE_URL}/wp-json/custom/v1/fav-icon`,
                fromData2,
                config2
              )
              .then((res) => {
                console.log(res);
                //   setLogoUpload(logoUpload ? false : true);
                document.getElementById("fav_file").value = "";
                toast.success("Logo updated successfully");
              })
              .catch((err) => {
                console.log(err);
              });
            // } else {
            //     // Aspect ratio is not 40:13, show error message
            //     toast.error("Please upload a logo with aspect ratio 40:13");
            // }
          };
          img.src = imageURL;
        })

        .catch((err) => {
          console.log(err);
        });

    } else {
      // Handle case where the file name does not contain "logo"
      console.log("The file name must contain 'logo'. Upload skipped.");
      // Optionally show a message to the user (e.g., alert or toast)
      toast.error("Please upload a file with 'logo' in its name.");
    }
  };

  const givenFileSizeChange = (e) => {
    // console.log(typeof e.target.value);
    setFileSize(parseInt(e.target.value));
  };

  const saveFileSize = () => {
    const totalFileSize = { given_size: fileSize };

    axios
      .post(
        `${API_BASE_URL}/wp-json/custom/v1/track-filesize`,
        totalFileSize,
        config2
      )
      .then((response) => {
        console.log("Response data:", response.data);
        // setFileSize("");
        toast.success("Data updated successfully");
      })
      .catch((error) => {
        console.log("Error:", error);
      });
  };
  const givenAdminEmailChange = (e) => {
    setAdminEmail(e.target.value);
  };
  const saveAdminEmail = () => {
    const data = { email: adminEmail };

    axios
      .post(
        `${API_BASE_URL}/wp-json/custom/v1/store-global-email`,
        data,
        config2
      )
      .then((response) => {
        console.log("Response data:", response.data);
        // setFileSize("");
        toast.success("Data updated successfully");
      })
      .catch((error) => {
        console.log("Error:", error);
      });
  };
  return (
    <div>
      <NewTopNavBar />
      <div className="container pb-5">
        <div className="row">
          <div className="col-3"></div>
          <div className="col-6">
            <div className="form-group pt-5 ">
              <label className="fw-bold">Upload logo:</label>

              <div className="d-flex align-items-center">
                <input
                  className="form-control my-2 W-75"
                  type="file"
                  accept="image/*"
                  id="file"
                  label="Choose image upload"
                  onChange={handleFileChange}
                />
                <img
                  className="ms-2 commonLogo"
                  // width={40}
                  onClick={handleLogoUpload}
                  data-toggle="tooltip"
                  data-placement="bottom"
                  title="Upload"
                  role="button"
                  src={UploadImage}
                  alt=""
                />
              </div>
            </div>

            <div className="form-group pt-5 ">
              <label className="fw-bold">Upload Favicon:</label>

              <div className="d-flex align-items-center">
                <input
                  className="form-control my-2 W-75"
                  type="file"
                  accept="image/*"
                  id="fav_file"
                  label="Choose image upload"
                  onChange={handleFavIconChange}
                />
                <img
                  className="ms-2 commonLogo"
                  // width={40}
                  onClick={handleFavIconUpload}
                  data-toggle="tooltip"
                  data-placement="bottom"
                  title="Upload"
                  role="button"
                  src={UploadImage}
                  alt=""
                />
              </div>
            </div>

            <div className="form-group pt-5 ">
              {/* <label className="fw-bold">Upload Widget logo:</label>

              <div className="d-flex align-items-center">
                <input
                  className="form-control my-2 W-75"
                  type="file"
                  accept="image/*"
                  id="fav_file"
                  label="Choose image upload"
                  // onChange={handleWidgetLogoChange}
                />
                <img
                  className="ms-2"
                  width={40}
                  // onClick={handleWidgetLogoUpload}
                  data-toggle="tooltip"
                  data-placement="bottom"
                  title="Upload"
                  role="button"
                  src={UploadImage}
                  alt=""
                />
              </div> */}
              {/* color picker start */}
              <div
                className=""
              // style={{ display: "flex", justifyContent: "space-around" }}
              >
                <div className="sketchpicker">
                  <h6>Choose widget icon background color:</h6>
                  {/* Div to display the color  */}
                  <div
                    className="mb-1"
                    style={{
                      // backgroundColor: `rgba(${r},${g},${b},${a})`,
                      backgroundColor: widgetIcon,
                      width: 100,
                      height: 50,
                      border: "2px solid white",
                    }}
                  ></div>
                  {/* Sketch Picker from react-color and handling color on onChange event */}
                  <SketchPicker
                    onChange={(color) => {
                      setSketchPickerColor(color.rgb);
                    }}
                    color={sketchPickerColor}
                  />
                </div>
                <div className="">
                  {/* <Button onClick={saveColor}>Save</Button> */}
                  <img
                    className="mt-2"
                    data-toggle="tooltip"
                    data-placement="bottom"
                    title="Save"
                    role="button"
                    onClick={saveColor}
                    src={SaveImg}
                    alt=""
                  />
                </div>
              </div>
              {/* color picker end */}
            </div>

            <div className="pt-5">
              <label className="fw-bold mb-2">Storage Capacity: (In GB)</label>
              <div className="d-flex">
                <input
                  type="number"
                  className="form-control"
                  value={fileSize}
                  // style={{ width: "80%" }}
                  onChange={givenFileSizeChange}
                />
                <img
                  className="ms-2 commonLogo"
                  // width={40}
                  onClick={saveFileSize}
                  data-toggle="tooltip"
                  data-placement="bottom"
                  title="Save"
                  role="button"
                  src={Rightarrow}
                  alt=""
                />
              </div>
            </div>
            <div className="pt-5 ">
              <label className="fw-bold mb-2">Add Admin Email</label>
              <div className="d-flex">
                <input
                  type="email"
                  className="form-control"
                  value={adminEmail}
                  // style={{ width: "80%" }}
                  onChange={givenAdminEmailChange}
                />
                <img
                  className="ms-2 commonLogo"
                  // width={40}
                  onClick={saveAdminEmail}
                  data-toggle="tooltip"
                  data-placement="bottom"
                  title="Save"
                  role="button"
                  src={Rightarrow}
                  alt=""
                />
              </div>
            </div>
            {/* <div className="form-group pt-2 ">
                            <label className='fw-bold'>Update favicon:</label>

                            <div className='d-flex align-items-center'>
                                <input
                                    className='form-control my-2 W-75'

                                    type='file'
                                    accept="image/*"
                                    id="file"
                                    label="Choose image upload"
                                    onChange={handleFavIconChange}
                                />
                                <img className='ms-2' width={40} onClick={handleFavIconUpload} data-toggle="tooltip" data-placement="bottom" title="Upload" role='button' src={UploadImage} alt="" />
                            </div>
                        </div> */}
          </div>
          <div className="col-3"></div>
        </div>
      </div>
    </div>
  );
};

export default GlobalLogo;
